import React from "react";
import Slider from "react-slick";
import { motion } from "framer-motion";
import { StarIcon, UserCircleIcon } from "@heroicons/react/24/solid";

// Testimonials Data
const testimonials = [
  {
    name: "Aarav Mehta",
    role: "HR Manager, Infonex Ltd",
    feedback:
      "GTPL HRMS transformed our  operations. Payroll accuracy increased, onboarding became smoother, and employee engagement improved drastically.",
  },
  {
    name: "Riya Sharma",
    role: "People Operations, Vertex Digital",
    feedback:
      "Workflow automation reduced manual HR tasks by nearly 60%. Leave, attendance, and approvals now take minutes instead of hours.",
  },
  {
    name: "Harshit Patel",
    role: "CEO, SoftZen Technologies",
    feedback:
      "Enterprise-grade security and analytics make managing a 600+ workforce effortless. A true HRMS built for scalability.",
  },
  {
    name: "Priyanka Rao",
    role: "HRBP, CloudSphere",
    feedback:
      "The UI is clean, intuitive, and mobile-friendly. Employee self-service is smooth and dramatically improved our HR interactions.",
  },
];

const Testimonials = () => {
  const settings = {
    dots: true,
    infinite: true,
    speed: 700,
    autoplay: true,
    autoplaySpeed: 4500,
    arrows: false,
    slidesToShow: 3,
    slidesToScroll: 1,
    pauseOnHover: false,

    // FIXED MOBILE RESPONSIVENESS
    responsive: [
      {
        breakpoint: 1280,
        settings: {
          slidesToShow: 2,
          centerMode: false,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
          centerMode: true,
          centerPadding: "20px",
        },
      },
    ],
  };

  return (
    <section
      className="py-24 bg-white"
      style={{ fontFamily: "Poppins, Roboto, sans-serif" }}
    >
      {/* HEADER */}
      <div className="max-w-6xl mx-auto px-6 mb-16 text-center">
        <motion.h2
          initial={{ opacity: 0, y: 25 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          className="text-3xl sm:text-4xl font-bold text-gray-900"
        >
          Trusted by{" "}
          <span className="bg-gradient-to-r from-teal-500 to-blue-600 bg-clip-text text-transparent">
            HR Professionals
          </span>
        </motion.h2>

        <motion.p
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          transition={{ delay: 0.2, duration: 0.6 }}
          className="text-gray-600 text-base sm:text-lg mt-3 max-w-2xl mx-auto"
          style={{ fontFamily: "Roboto, sans-serif" }}
        >
          Real experiences from organizations that improved their HR workflows,
          automation, and employee satisfaction using GTPL HRMS.
        </motion.p>
      </div>

      {/* SLIDER */}
      <div className="max-w-7xl mx-auto px-4 sm:px-6">
        <Slider {...settings}>
          {testimonials.map((t, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, scale: 0.95 }}
              whileInView={{ opacity: 1, scale: 1 }}
              transition={{ duration: 0.5 }}
              viewport={{ once: true }}
              className="px-2 sm:px-3"
            >
              <div
                className="
                bg-white
                rounded-2xl
                p-6 sm:p-8
                border
                border-gray-200
                shadow-sm
                hover:shadow-xl
                hover:border-transparent
                hover:bg-gradient-to-br
                hover:from-teal-50
                hover:to-blue-50
                transition-all
                duration-300
                min-h-[280px]
                sm:min-h-[300px]
                flex
                flex-col
              "
              >
                {/* STAR RATING */}
                <div className="flex space-x-1 mb-4">
                  {[...Array(5)].map((_, i) => (
                    <StarIcon key={i} className="w-5 h-5 text-amber-400" />
                  ))}
                </div>

                {/* FEEDBACK */}
                <p
                  className="text-gray-700 text-sm sm:text-base leading-relaxed mb-6"
                  style={{ fontFamily: "Roboto, sans-serif" }}
                >
                  {t.feedback}
                </p>

                {/* USER FOOTER */}
                <div className="mt-auto flex items-center gap-3 pt-5 border-t border-gray-100">
                  <UserCircleIcon className="w-10 h-10 sm:w-12 sm:h-12 text-teal-600 shadow-sm" />

                  <div>
                    <h4
                      className="text-sm sm:text-base font-semibold text-gray-900"
                      style={{ fontFamily: "Poppins, sans-serif" }}
                    >
                      {t.name}
                    </h4>
                    <p
                      className="text-xs sm:text-sm text-gray-500"
                      style={{ fontFamily: "Roboto, sans-serif" }}
                    >
                      {t.role}
                    </p>
                  </div>
                </div>
              </div>
            </motion.div>
          ))}
        </Slider>
      </div>
    </section>
  );
};

export default Testimonials;
